import { Icons } from '@assets';
import booking from '@config/navigation/items/booking';
import crm from '@config/navigation/items/crm';
import rkeeper from '@config/navigation/items/rkeeper';
import settings from '@config/navigation/items/settings';
import { IAcl, INavMenuItem } from '@types';
import { isAllow } from '@utils/functions';
import React from 'react';

const { HeaderIcons } = Icons;

export const navbar = (rules: IAcl | undefined): INavMenuItem[] => [
    {
        name: 'Дашборд ',
        to: '/dashboard',
        navKey: 'dashboard',
        icon: <img src={HeaderIcons.IconHeaderRkeeper} alt="Proga.pro logo" />,
        text: 'Дашборд',
        height: 195,
        isAllow: isAllow(rules, 'dashboard'),
    },
    {
        name: 'RKeeper ',
        to: '/rkeeper',
        navKey: 'rkeeper',
        icon: <img src={HeaderIcons.IconHeaderRkeeper} alt="Proga.pro logo" />,
        text: 'rkeeper',
        height: 195,
        isAllow: isAllow(rules, 'rkeeper'),
        subs: rkeeper(rules),
    },
    {
        name: 'Бронирование',
        to: '/booking',
        navKey: 'booking',
        icon: <img src={HeaderIcons.IconHeaderRkeeper} alt="Proga.pro logo" />,
        text: 'booking',
        height: 195,
        isAllow: isAllow(rules, 'booking'),
        subs: booking(rules),
    },
    {
        name: 'CRM ',
        to: '/crm',
        navKey: 'crm',
        icon: <img src={HeaderIcons.IconHeaderRkeeper} alt="Proga.pro logo" />,
        text: 'crm',
        height: 195,
        isAllow: isAllow(rules, 'crm'),
        subs: crm(rules),
    },
    {
        name: 'Настройки',
        to: '/settings',
        navKey: 'settings',
        icon: <img src={HeaderIcons.IconHeaderRkeeper} alt="Proga.pro logo" />,
        text: 'settings',
        height: 120,
        isAllow: isAllow(rules, 'settings'),
        subs: settings(rules),
    },
];

export default navbar;
